export default __webpack_public_path__ + "madfit-screen-fourth.bf970d71.png";